{
  "placeholder": "Rhowch {fieldName}",
  "email": "E-bost",
  "validEmail": "Rhaid i'r e-bost fod yn ddilys",
  "password": "Cyfrinair",
  "validPassword": "Rhaid i'r cyfrinair gynnwys o leiaf 8 nod, gan gynnwys 1 priflythyren, 1 llythyren fach, 1 rhif ac 1 nod arbennig",
  "passwordsDontMatch": "Nid yw'r cyfrineiriau'n cyfateb",
  "newPassword": "Cyfrinair newydd",
  "confirmPassword": "Cadarnhau cyfrinair",
  "confirmPasswordPlaceholder": "Cadarnhewch y cyfrinair",
  "confirmNewPassword": "Cadarnhau cyfrinair newydd",
  "confirmNewPasswordPlaceholder": "Cadarnhewch y cyfrinair newydd",
  "oldPassword": "Hen gyfrinair",
  "verificationCode": "Cod dilysu",
  "validVerificationCode": "Rhaid i'r cod dilysu gynnwys 6 rhif",
  "verificationCodeRequired": "Mae angen cod dilysu",
  "name": "Enw",
  "surname": "Cyfenw",
  "telNumber": "Rhif ffôn",
  "mobileNumber": "Rhif ffôn symudol",
  "countryRegion": "Gwlad / Rhanbarth",
  "validPhoneNumber": "Rhowch rif ffôn dilys",
  "submit": "Cyflwyno",
  "update": "Diweddaru",
  "submitVerificationCode": "Cyflwyno cod dilysu",
  "csvInvalid": "Mae un o'r URLau wedi'u gwahanu gan goma yn annilys",
  "selectDatetime": "Dewis dyddiad/amser",
  "asap": "Cyn gynted â phosibl",
  "selectAddress": "Dewis cyfeiriad",
  "searchPostcodeOrAddress": "Chwilio cod post neu gyfeiriad",
  "filterNicknameOrAddress": "Hidlo llysenw neu gyfeiriad",
  "searchFor": "Chwilio am {label}",
  "select": "Dewis {label}",
  "toPayment": "Mynd i'r taliad",
  "addressForm": {
    "addAddress": "Ychwanegu cyfeiriad",
    "editAddress": "Golygu cyfeiriad",
    "labels": {
      "code": "Llysenw",
      "addressName": "Enw cwmni/cyfeiriad",
      "address1": "Llinell cyfeiriad 1",
      "address2": "Llinell cyfeiriad 2",
      "address3": "Tref/Dinas",
      "address4": "Sir",
      "postcode": "Cod post",
      "notes": "Nodiadau"
    },
    "placeholders": {
      "code": "Enghraifft: HQ",
      "addressName": "Enghraifft: Example Solutions Ltd",
      "address1": "Enghraifft: 123 Example Street",
      "address2": "Enghraifft: Innovation Park",
      "address3": "Enghraifft: London",
      "address4": "Enghraifft: Greater London",
      "postcode": "Enghraifft: SW1A 1AA",
      "notes": "Enghraifft: Prif gyfeiriad swyddfa"
    },
    "useAsDefault": "Defnyddio fel diofyn",
    "submitInsert": "Ychwanegu",
    "submitUpdate": "Diweddaru",
    "deleteAddress": "Dileu cyfeiriad",
    "deleteAddressAlert": "Dileu'r cyfeiriad hwn?",
    "insertSuccessToast": "Cyfeiriad wedi'i ychwanegu",
    "insertFailToast": "Methu ychwanegu cyfeiriad",
    "editSuccessToast": "Cyfeiriad wedi'i ddiweddaru",
    "editFailToast": "Methu diweddaru cyfeiriad",
    "deleteSuccessToast": "Cyfeiriad wedi'i ddileu",
    "deleteFailToast": "Methu dileu cyfeiriad"
  },
  "format": "Fformat: {formats} | Fformatau: {formats}",
  "isRequired": "Mae {fieldName} yn ofynnol",
  "mustBeWholeNum": "Rhaid i {fieldName} fod yn rif cyfan",
  "mustBeNum": "Rhaid i {fieldName} fod yn rhif",
  "mustBeTwoDecimalPlaces": "Rhaid i {fieldName} fod â 2 ddigid neu lai ar ôl y pwynt degol",
  "equalTo": "Yn hafal i",
  "equalGreaterThan": "Yn hafal/i fwy na",
  "equalLessThan": "Yn hafal/i lai na",
  "greaterThan": "Yn fwy na",
  "lessThan": "Yn llai na",
  "isNull": "Yn wag",
  "isNotNull": "Nid yw'n wag",
  "isOneOf": "Yn un o",
  "isNotOneOf": "Nid yw'n un o",
  "between": "Rhwng",
  "contains": "Yn cynnwys",
  "flightDate": "Dyddiad hediad",
  "flightNumber": "Rhif hediad",
  "holdOff": "Dal yn ôl",
  "complete": "Cwblhau {section}",
  "sendConfirmation": {
    "submit": "Anfon",
    "title": "Anfon cadarnhad",
    "otherEmail": "E-bost arall",
    "emailErrorText": "Dewiswch neu nodwch gyfeiriad e-bost dilys"
  },
  "tariff": {
    "viewOnlyMessage": "Ffoniwch ni i archebu'r gwasanaeth hwn",
    "unavailableMessage": "Dewiswch wasanaeth sydd ar gael",
    "unavailableRibbonMessage": "Ffoniwch i archebu",
    "bookMessage": "Archebu - {tariff}",
    "sortLabel": "Trefnu tariffau yn ôl"
  },
  "stops": {
    "accordionHeader": "Manylion",
    "asDirectedLabel": "Fel y cyfarwyddwyd",
    "missingAddressStopMessage": "Stop ar goll"
  },
  "vouchers": {
    "vouchersAddedCount": "1 taleb wedi'i hychwanegu | {count} o dalebau wedi'u hychwanegu",
    "maxVouchersMessage": "Gellir ychwanegu uchafswm o {maxVouchers} taleb",
    "addVoucherButton": "Ychwanegu taleb",
    "noVouchersMessage": "Dim talebau wedi'u hychwanegu",
    "voucherNumber": "Taleb #{num}",
    "voucherCode": "Cod: {voucherCode}",
    "enterVoucherCode": "Rhowch god taleb"
  },
  "arriveByAwaitingDetailsMessage": "Cwblhewch fanylion yr archeb i weld yr amser cyrraedd",
  "goodButtons": {
    "copy": "Copïo {good}",
    "remove": "Tynnu {good}",
    "add": "Ychwanegu {good}"
  },
  "maxGoodsQtyMessage": "Ni all cyfanswm yr holl nwyddau fod yn fwy na {max}",
  "maxGoodsCartonsMessage": "Ni all cyfanswm cartonau'r holl nwyddau fod yn fwy na {max}",
  "quickQuoteBookingMessage": "Er mwyn cwblhau eich archeb, mewngofnodwch neu crëwch gyfrif {app}",
  "termsAndConditions": {
    "message": "Drwy wneud yr archeb hon rydych yn cytuno i'r",
    "link": "telerau ac amodau archebu",
    "afterMessage": ""
  },
  "cancelBooking": {
    "submit": "Canslo",
    "otherReason": "Rheswm arall",
    "message": "Rhowch reswm",
    "reasonErrorText": "Dewiswch neu nodwch reswm canslo dilys"
  }
}
